<template><!-- svgo-optimised -->
<svg class="icon icon__plus" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.454 11.5v1.25h-16V11.5z"/><path d="M12.954 20h-1.25V4h1.25z"/></svg>
</template>